import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ShieldCaution20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M10.75 4.5V10.5H9.25V4.5H10.75Z' fill='currentColor' />
    <path
      d='M10 14C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4203 0.353766C10.1485 0.25667 9.85138 0.256671 9.57951 0.353769L3.07958 2.6752C2.58282 2.85261 2.25 3.32289 2.25 3.85193V13.5C2.25 14.3066 2.82204 15.002 3.36359 15.5415C5.07017 17.2417 7.31819 18.4594 9.43676 19.5545C9.79259 19.7384 10.2073 19.7384 10.5631 19.5545C12.6817 18.4594 14.9298 17.2417 16.6364 15.5415C17.1779 15.002 17.75 14.3066 17.75 13.5V3.85193C17.75 3.32289 17.4172 2.85261 16.9204 2.6752L10.4203 0.353766ZM3.75 4.02855L9.99993 1.79641L16.25 4.02855V13.5C16.25 13.8555 15.8016 14.2559 15.5777 14.4789C14.0136 16.0371 11.9365 17.1453 9.99993 18.1567C8.06339 17.1453 5.9863 16.0371 4.42225 14.4789C4.19838 14.2559 3.75 13.8555 3.75 13.5V4.02855Z'
      fill='currentColor'
    />
  </Svg>
);

ShieldCaution20.displayName = 'ShieldCaution20';
export default ShieldCaution20;
